import { render, staticRenderFns } from "./EmbedApp.vue?vue&type=template&id=3049475f&"
import script from "./EmbedApp.vue?vue&type=script&lang=js&"
export * from "./EmbedApp.vue?vue&type=script&lang=js&"
import style0 from "./EmbedApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports